import { render, staticRenderFns } from "./veStuGraduationByzbhRuleEdit.vue?vue&type=template&id=1196f6d5&scoped=true"
import script from "./veStuGraduationByzbhRuleEdit.vue?vue&type=script&lang=js"
export * from "./veStuGraduationByzbhRuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196f6d5",
  null
  
)

export default component.exports